import { Box } from "@chakra-ui/react"
import styles from "./animation.module.css"

function TileTooltip() {
  return (
    <Box
      position="absolute"
      fontSize="16px"
      fontFamily="Rubik"
      fontWeight="bold"
      height="1.8rem"
      left="50%"
      top="0"
      transform="translateX(-50%)"
      background="#0D0A04"
      color="#c5b8ac"
      padding="0 .6em"
      borderRadius="8px"
      border="2px solid #8C7765"
      animation={`2s ease-in-out infinite alternate both ${styles.hovering}`}
    >
      Start
      <Box
        width={0}
        height={0}
        borderStyle="solid"
        borderWidth="11px 10.1px 0 10.1px"
        borderColor="#8C7765 transparent transparent transparent"
        transform="translateY(1px) translateX(-50%)"
        left="50%"
        position="absolute"
      />
      <Box
        width={0}
        height={0}
        borderStyle="solid"
        borderWidth="9px 8.1px 0 8.1px"
        borderColor="#0D0A04 transparent transparent transparent"
        transform="translateX(-50%)"
        left="50%"
        position="absolute"
      />
    </Box>
  )
}

export default TileTooltip
